import { render, staticRenderFns } from "./TranslatorThumbVoteOutput.vue?vue&type=template&id=eeffdbc4&scoped=true"
import script from "./TranslatorThumbVoteOutput.vue?vue&type=script&lang=js"
export * from "./TranslatorThumbVoteOutput.vue?vue&type=script&lang=js"
import style0 from "./TranslatorThumbVoteOutput.vue?vue&type=style&index=0&id=eeffdbc4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_qfdn4gbztslujeagaknuyibsmy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eeffdbc4",
  null
  
)

export default component.exports